import { styled, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import BaseButton from '../common/BaseButton';
import { Copy, Login } from 'iconsax-react';

const SparkleIcon = styled('img')({
  width: 16,
  height: 16,
});

const AIButton = ({
  theme = 'main',
  children,
  type = 'sparkle',
  isCollapsed = false,
  ...props
}) => {
  const muiTheme = useTheme();

  const getIcon = () => {
    if (type === 'sparkle') {
      return <SparkleIcon src="/static/img/icon/sparkle.svg" alt="AI" />;
    }
    if (type === 'copy' && isCollapsed) {
      return (
        <Login
          size={20}
          color={muiTheme.palette.mode === 'dark' ? '#1A1B1F' : '#FFFBFF'}
        />
      );
    }
    return null;
  };

  const getContent = () => {
    if (type === 'copy' && isCollapsed) {
      return null;
    }
    return children;
  };

  return (
    <BaseButton {...props} color={theme} variant="contained" icon={getIcon()}>
      {getContent()}
    </BaseButton>
  );
};

AIButton.propTypes = {
  theme: PropTypes.string,
  children: PropTypes.node,
  type: PropTypes.oneOf(['sparkle', 'copy']),
  isCollapsed: PropTypes.bool,
};

export default AIButton;
